import Chart from "chart.js";
import Moment from "moment";
import * as React from "react";
import { UserContext } from "../context/UserContext";
import { thousandSeparator } from "../services/StringUtil";
import ConsumptionComparisonModal from "./ConsumptionComparison";

interface Props {}

interface State {}

Chart.defaults.global.defaultFontFamily = "'Roboto Slab', sans-serif";
Chart.defaults.global.legend.display = false;

export class Consumption extends React.Component<Props, State> {
  static contextType = UserContext;
  context!: React.ContextType<typeof UserContext>;

  private chartRef: React.RefObject<HTMLCanvasElement> = React.createRef();
  private chart: Chart;

  state = {};

  componentDidMount() {
    this.updateConsumption();
  }

  componentDidUpdate() {
    this.updateConsumption();
  }

  initChart() {
    if (this.chart) {
      return;
    }

    if (!this.chartRef.current) {
      return;
    }

    const chartContext = this.chartRef.current.getContext("2d");
    this.chart = new Chart(chartContext, {
      type: "bar",
      data: {
        labels: [
          "Januari",
          "Februari",
          "Mars",
          "April",
          "Maj",
          "Juni",
          "Juli",
          "Augusti",
          "September",
          "Oktober",
          "November",
          "December",
        ],
        datasets: [
          {
            label: "I år",
            backgroundColor: "#66aa66",
          },
          {
            label: "Förra året",
            backgroundColor: "#dddddd",
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              ticks: {
                fontColor: "#000000",
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                fontColor: "#000000",
                min: 0,
                max: 5000,
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              var label = data.datasets[tooltipItem.datasetIndex].label || "";

              if (label) {
                label += ": ";
              }
              label += tooltipItem.yLabel + " kWh";
              return label;
            },
          },
        },
      },
    });
  }

  updateConsumption = async () => {
    if (!this.context.currentElavtal) {
      return;
    }

    this.initChart();

    const client = this.context.getClient();
    const consumptions = await client.consumption(
      this.context.currentElavtal.property.id,
      window.location.href,
      this.context.currentElavtal.id
    );
    console.debug("Got consumptions", consumptions);
    let lastYear = Array(12).fill(0);
    let max = 0;
    consumptions
      .filter((consumption) => consumption.year == Moment().year() - 1)
      .forEach((consumption) => {
        lastYear[consumption.month - 1] = consumption.amount;
        max = Math.max(max, consumption.amount);
      });

    let thisYear = Array(12).fill(0);
    consumptions
      .filter((consumption) => consumption.year == Moment().year())
      .forEach((consumption) => {
        thisYear[consumption.month - 1] = consumption.amount;
        max = Math.max(max, consumption.amount);
      });

    this.chart.data.datasets[0].data = thisYear;
    this.chart.data.datasets[1].data = lastYear;

    const interval = max > 500 ? 1000 : 100;

    // set max value on scale to highest 1000
    max = Math.floor(max / interval + 1) * interval;
    this.chart.config.options.scales.yAxes[0].ticks.max = max;
    this.chart.update();
  };

  render() {
    return this.context.currentElavtal ? (
      <div>
        <h2>Min förbrukning</h2>
        {this.context.currentElavtal.property.consumption > 0 && (
          <p className="copy">
            Din beräknade årsförbrukning är{" "}
            {thousandSeparator(
              this.context.currentElavtal.property.consumption
            )}{" "}
            kWh per år. Se Energimarknadsbyråns information om snittförbrukning{" "}
                    <a href="#consumptionComparisonModal" data-toggle="modal">
                     här.
                    </a>
          </p>
        )}
        <div className={"consumption-container"}>
          <canvas id="consumption-chart" ref={this.chartRef} height="250px" />
        </div>
        <ConsumptionComparisonModal/>
      </div>
     
    ) : null;
    
  }
}
